import { Component, DestroyRef, effect, inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { API, ClientDTO, CompanyDTO, ReportingFullDTO, UserClientFullDTO } from '../../services/api/api';
import { APIService } from '../../services/api/api.service';
import { ErrorService } from '../../services/error.service';
import { ChangelogService } from '../../services/gui/changelog/changelog.service';
import { ModalService } from '../../services/gui/modal/modal.service';
import { NavpointsService } from '../../services/navpoints.service';
import { UserService } from '../../services/user.service';
import { UtilService } from '../../services/util.service';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationService } from 'src/app/services/notifications/notification.service';
import { DateTime } from 'luxon';
import { SbAccessibleClientsComponent } from 'src/app/components/sb-accessible-clients/sb-accessible-clients.component';
import { DiscussionService } from 'src/app/services/discussion.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs';
import { SbDropdown, SbDropdownItem } from '../../components/sb-level-dropdown/sb-level-dropdown.component';
import { RoutingID } from '../../routes/sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { Permission } from '../../services/api/permission';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { SbNavpointModel } from '@ngx-seatback/layout';
import { NavigationService } from '@ngx-seatback/utils';
import { CompaniesComponent } from '../company/companies/companies.component';
import { StorageService } from '../../services/storage.service';
import { ReportingService } from '../../services/reporting.service';
import { PermissionService } from '../../services/permission.service';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { KiService } from '../../components/ki/ki.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('popup', [
      transition('void => *', [style({ transform: 'scale3d(.3, .3, .3)' }), animate(100)]),
      transition('* => void', [animate(100, style({ transform: 'scale3d(.0, .0, .0)' }))]),
    ]),
    trigger('slideInOut', [
      transition(':enter', [style({ transform: 'translateX(+100%)' }), animate('200ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(+100%)' }))]),
    ]),
    trigger('slideInOutKI', [
      transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('200ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(-100%)' }))]),
    ]),
    trigger('fadeAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate(400)]),
      transition(':leave', animate(400, style({ opacity: 0 }))),
    ]),
  ],
  standalone: false,
})
export class HomeComponent implements OnInit {
  protected readonly kiService = inject(KiService);

  snowArray = [];
  userMenu: SbDropdown = {
    width: 270,
    type: 'mainMenu',
    items: [
      {
        name: _('nav.client.myProfile'),
        translate: true,
        icon: SbIcons.userManagement,
        link: RoutingID.user,
      },
      {
        name: _('lang.settings.defaultLang'),
        translate: true,
        icon: SbIcons.language,
        subDropdown: {
          name: _('lang.settings.defaultLang'),
          translate: true,
          type: 'language',
          items: [
            {
              name: _('lang.globals.english'),
              translate: true,
              image: './assets/img/226-united-states.svg',
              action: 'en',
              selected: false,
            },
            {
              name: _('lang.globals.german'),
              translate: true,
              image: './assets/img/162-germany.svg',
              action: 'de',
              selected: false,
            },
          ],
        },
      },
      {
        name: _('nav.themeMode'),
        translate: true,
        icon: SbIcons.darkmodeMoon,
        subDropdown: {
          name: _('nav.themeMode'),
          translate: true,
          type: 'themes',
          items: [
            {
              name: _('nav.themeMode.lightTheme'),
              translate: true,
              icon: SbIcons.darkmodeSun,
              action: 'light-theme',
              selected: false,
            },
            {
              name: _('nav.themeMode.darkTheme'),
              translate: true,
              icon: SbIcons.darkmodeMoon,
              action: 'dark-theme',
              selected: false,
            },
          ],
        },
      },
      {
        name: _('nav.viewMode'),
        translate: true,
        icon: SbIcons.template,
        subDropdown: {
          name: _('nav.viewMode'),
          translate: true,
          type: 'viewMode',
          items: [
            {
              name: _('nav.viewMode.cardView'),
              translate: true,
              icon: SbIcons.pools,
              action: 'card',
              selected: false,
            },
            {
              name: _('nav.viewMode.listView'),
              translate: true,
              icon: SbIcons.list,
              action: 'list',
              selected: false,
            },
          ],
        },
        separatorAfter: true,
      },
      {
        name: _('nav.notifications'),
        translate: true,
        icon: SbIcons.bell,
        link: RoutingID.notification,
        permissions: [Permission.notification_list],
      },
      /*      {
              name: _('nav.client.myCompany'),
              translate: true,
              icon: SbIcons.companyClient,
              link: RoutingID.client,
            },*/
      {
        name: _('lang.globals.clientSettings'),
        translate: true,
        icon: SbIcons.companyClient,
        link: RoutingID.client,
      },
    ],
  };
  newNotifications: boolean;
  notificationsAlerts: boolean;
  noPic: string = './assets/img/no-profile-man.png';
  noCompanyAvatar: string = './assets/img/no-image.png';
  avatar: string;
  companyAvatar: string;
  translateSub: Subscription = null;
  reports: ReportingFullDTO[];

  constructor(
    private readonly translate: TranslateService,
    public readonly navpointsService: NavpointsService,
    private readonly api: API,
    private readonly apiService: APIService,
    private readonly router: Router,
    public readonly modal: ModalService,
    private readonly changelogService: ChangelogService,
    public readonly errorHandler: ErrorService,
    public readonly util: UtilService,
    public readonly userService: UserService,
    // public readonly notificationService: NotificationService,
    public readonly discussionService: DiscussionService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly navigationService: NavigationService,
    private readonly storageService: StorageService,
    private readonly reportingService: ReportingService,
    public readonly permissionService: PermissionService,
    private readonly destroyRef: DestroyRef
  ) {
    this.notificationsAlerts = false;
    this.reports = [];
    effect(() => {
      const userSettings = this.userService.currentUserSettings();
      if (userSettings !== null) {
        // check for separate signal ? .viewSettingService.defaultViewSetting(), selectedlanguage, themingserviec and debugmode
        this.verifySettings(userSettings.themeSetting, 'themes'); // instead of themingService subscription
        // this.userService.checkForDebug(data); not necessary since computed signal is calculated
        // this.initNavpoints(); // moved to separate effect
      }
    });

    effect(() => {
      const defaultViewSetting = this.userService.defaultViewSetting();
      this.verifySettings(defaultViewSetting, 'viewMode'); // instead of ViewSettingService viewSettingObj subscription
    });

    effect(() => {
      const language = this.userService.selectedLanguage();
      this.verifySettings(language, 'language'); // instead of languageObs subscription
      this.initNavpoints();
    });

    this.reportingService.reportQueue.subscribe((reports: ReportingFullDTO[]) => {
      this.reports = reports;
    });

    /*
    this.notificationService.onNewNotifications.subscribe(() => {
      this.newNotifications = true;
      setTimeout(() => {
        this.newNotifications = false;
        this.showNotificationsAlerts();
      }, 2000);
    });
    this.notificationService.restart();
     */
    this.avatar = this.noPic;
    this.companyAvatar = this.noCompanyAvatar;

    // close all modals when leaving page
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.modal.dismissAll();
      }
    });
  }

  /*
  showNotificationsAlerts() {
    if (this.notificationService.totalPendingNotificationsCount > 0) {
      this.notificationsAlerts = true;
    }
  }

 */

  verifySettings(data: string, type: string) {
    if (!data) {
      return;
    }
    for (const item of this.userMenu.items) {
      if (item.subDropdown && item.subDropdown.type === type) {
        for (const subItem of item.subDropdown.items) {
          if (typeof data === 'string') {
            subItem.selected = subItem.action === data;
          }
        }
      }
    }
  }

  resolveDropdownAction(item: SbDropdownItem) {
    if (item.action === 'dark-theme' || item.action === 'light-theme') {
      this.userService.setUserSetting('themeSetting', item.action).then(() => {});
    }
    if (item.action === 'card' || item.action === 'list') {
      this.userService.setUserSetting('defaultView', item.action).then(() => {});
    }
    if (item.action === 'de' || item.action === 'en') {
      this.userService.setUserSetting('defaultLang', item.action).then(() => {});
    }
  }

  ngOnInit() {
    if (this.isChristmas()) {
      // this.letItSnow(190);
    }
    this.translateSub = this.translate.onLangChange.subscribe(() => {
      this.initNavpoints();
    });
    const userClient: UserClientFullDTO = this.userService.user;
    this.activatedRoute.params.subscribe(params => {
      this.navigationService.setGlobalParams(params);
      this.router
        .navigateByUrl(this.router.url.replace(params.clientID, userClient.client.id), {
          replaceUrl: true,
        })
        .then();
    });

    this.setAvatar(userClient);

    this.storageService.fetch(sessionStorage, this.userService.user.client.id).then(data => {
      const sessionData = JSON.parse(data);
      if (sessionData?.company) {
        this.userService.selectedCompany.next(sessionData.company);
      } else {
        this.userService.selectedCompany.next(null);
      }
    });
  }

  initNavpoints() {
    let map: Map<string, SbNavpointModel[]>;
    map = this.navpointsService.getNavpoints();
    this.navpointsService.navMain = map.get('main');
    this.navpointsService.navFooter = map.get('footer');
  }

  setAvatar(userClient: UserClientFullDTO) {
    this.avatar = userClient.user?.avatar?.url
      ? this.util.appendQueryParamToUrl(userClient.user.avatar.url as unknown as string, 'thumbnail=S')
      : this.noPic;
    this.companyAvatar = userClient.client?.primaryCompany?.logo?.url
      ? this.util.appendQueryParamToUrl(userClient.client.primaryCompany.logo.url as unknown as string, 'thumbnail=S')
      : this.noCompanyAvatar;
  }

  switchToClient(company: ClientDTO) {
    this.apiService.destroySubs();
    this.api
      .shared_Client_switchTo(company)
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: () => {
          this.apiService.destroySubs();
          this.storageService.fetch(sessionStorage, company.id).then(data => {
            const sessionData = JSON.parse(data);
            if (sessionData?.url) {
              // set stored session storage link as new link
              document.location.href = sessionData.url;
            } else if (document.location.href === '/client/:clientID/home') {
              window.location.reload();
            } else {
              document.location.href = '/client/:clientID/home';
            }
          });
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }

  showClients() {
    this.saveCurrentURL();
    this.modal
      .showNavigationModal({
        entryComponent: { value: SbAccessibleClientsComponent, data: { pauseNotifications: true } },
        title: null,
        modalOptions: {
          // windowClass: 'bigXL',
          size: 'xl',
        },
      })
      .then((result: ClientDTO) => {
        if (result?.id) {
          this.switchToClient(result);
        }
      })
      .catch(() => {});
  }

  switchToPrimaryClient(client: ClientDTO) {
    if (this.userService.user.user.primaryClient.id !== this.userService.user.client.id) {
      this.saveCurrentURL();
      const title: string = this.translate.instant('lang.home.switchClient');
      const message: string = this.translate.instant('lang.switchToClient.question', { client: client.name });
      this.modal
        .confirm({
          title,
          message,
          yes: this.translate.instant('lang.globals.yes'),
          no: this.translate.instant('lang.globals.no'),
        })
        .then((result: boolean) => {
          if (result) {
            this.switchToClient(client);
          }
        });
    }
  }

  signOut() {
    const title: string = this.translate.instant('lang.globals.signOut');
    const message: string = this.translate.instant('lang.signOut.question');
    this.modal
      .confirm({
        title,
        message,
        yes: this.translate.instant('lang.globals.yes'),
        no: this.translate.instant('lang.globals.no'),
      })
      .then((result: boolean) => {
        if (result) {
          this.userService.user = null;
          this.apiService.logout(true);
        }
      });
  }

  getFrontendVersion(): string {
    return this.changelogService.getFrontendVersion();
  }

  getBackendVersion(): string {
    return this.changelogService.getBackendVersion();
  }

  getFrontendChangelog(): string[] {
    return this.changelogService.getFrontendChangelog();
  }

  getBackendChangelog(): string[] {
    return this.changelogService.getBackendChangelog();
  }

  getFrontendName() {
    return this.changelogService.getFrontendName();
  }

  getBackendName() {
    return this.changelogService.getBackendName();
  }

  showFrontendChangelog() {
    this.changelogService.showFrontendChangelog();
  }

  showBackendChangelog() {
    this.changelogService.showBackendChangelog();
  }

  letItSnow(count) {
    const kek = [];

    for (let i = 0; i <= count; i++) {
      kek.push(i);
    }

    this.snowArray = kek;
  }

  isChristmas() {
    const christmasStart: DateTime = DateTime.local().set({ day: 1, month: 12, year: DateTime.local().year });
    const christmasEnd: DateTime = DateTime.local().set({ day: 31, month: 12, year: DateTime.local().year });
    const now = DateTime.local();
    return now >= christmasStart && now <= christmasEnd; // isChristmas var shortened.
  }

  toggleSideBar() {
    if (this.discussionService.showDiscussionSideBar) {
      this.discussionService.closeSideBar();
    } else {
      this.discussionService.openSideBar();
    }
  }

  saveCurrentURL() {
    this.storageService.fetch(sessionStorage, this.userService.user.client.id).then((res: string) => {
      let fetchObj = JSON.parse(res);
      if (fetchObj == null) {
        fetchObj = {};
      }
      fetchObj.url = this.router.url;
      this.storageService.store(sessionStorage, this.userService.user.client.id, JSON.stringify(fetchObj));
    });
  }

  showCompanySelectModal(): void {
    this.modal
      .showNavigationModal({
        entryComponent: { value: CompaniesComponent, data: {} },
        title: this.translate.instant('lang.globals.selectCompany'),
        modalOptions: { windowClass: 'bigXL' },
      })
      .then((result: CompanyDTO) => {
        if (result) {
          this.userService.selectedCompany.next(result);
          this.saveCompanyToSessionStorage(result);
        } else {
          this.userService.selectedCompany.next(null);
          this.saveCompanyToSessionStorage(null);
        }
      })
      .catch(() => {});
  }

  saveCompanyToSessionStorage(selectedCompany: CompanyDTO) {
    this.storageService.fetch(sessionStorage, this.userService.user.client.id).then((res: string) => {
      let fetchObj = JSON.parse(res);
      if (fetchObj == null) {
        fetchObj = {};
      }
      fetchObj.company = selectedCompany;
      this.storageService.store(sessionStorage, this.userService.user.client.id, JSON.stringify(fetchObj));
    });
  }
}
